import script from "./ceyizView.vue?vue&type=script&setup=true&lang=js"
export * from "./ceyizView.vue?vue&type=script&setup=true&lang=js"

import "./ceyizView.vue?vue&type=style&index=0&id=f3370e24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3370e24"]])

export default __exports__